<script setup>
import {ref, watch} from 'vue'
import SiteTreeContentArea from './SiteTreeContentArea.vue'
import {usePageTemplatesContentAreasStore} from '@/stores/pageTemplatesContentAreas'

const props = defineProps({
    siteTreeId: String,
    pageId: Number
})

const pageTemplatesContentAreasStore = usePageTemplatesContentAreasStore()

// Reactive ref for asynchronous content areas data (initialized with empty array fallback)
const contentAreas = ref([])

// Fetch content areas whenever props.pageId changes
watch(() => props.pageId, async (newPageId) => {
    if (newPageId) {
        contentAreas.value = (await pageTemplatesContentAreasStore.getPagesContentAreas(newPageId)) || []
    } else {
        contentAreas.value = []
    }
}, {immediate: true})
</script>

<template>
    <div class="ms-3 my-1 rounded-1 bg-secondary-subtle p-2 pt-1 small">
        <template v-if="contentAreas && contentAreas.length">
            <SiteTreeContentArea
                v-for="contentArea in contentAreas"
                :key="contentArea"
                :content-area="contentArea"
                :page-id="pageId"
                :site-tree-id="siteTreeId"
            />
        </template>
    </div>
</template>